import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

import { GetSessionUseCase } from '../../../core';
import { MainRoutes } from '../../main-routes.enum';
import { ParentEvents } from '../../utils/parent-events.service';

@Injectable()
export class UserAuthenticated implements CanActivate {
    constructor(private getSessionUseCase: GetSessionUseCase, private parentEvents: ParentEvents, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable((observer: Observer<boolean>) => {
            this.getSessionUseCase.bind().subscribe(
                (transaction) => {
                    if (transaction.isSuccess) {
                        observer.next(true);
                        observer.complete();
                    } else {
                        this.redirectToLogin();
                        observer.next(false);
                        observer.complete();
                    }
                },
                (err) => {
                    this.redirectToLogin();
                    observer.next(false);
                    observer.complete();
                }
            );
        });
    }

    private redirectToLogin(): void {
        this.parentEvents.logout();

        this.router.navigateByUrl(MainRoutes.UNAUTHORIZED);
    }
}
